import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "../../../../utils/api";

function Excavation() {
  const { id } = useParams();
  const [points, setPoints] = useState([]);

  useEffect(() => {
    api
      .get(`/api/excavation-points`, { params: { project_id: id } })
      .then((res) => {
        // Handle the API response structure: { status: "success", data: [...] }
        const pointsData = res.data.data || res.data || [];
        setPoints(pointsData);
      })
      .catch((err) => {
        console.error("Error fetching excavation points:", err);
        setPoints([]); // Set empty array as fallback
      });
  }, [id]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold flex items-center gap-2 text-primary-dark mb-6">
        <MapPin className="h-6 w-6" />
        Excavation Points (Project {id})
      </h1>

      {points.length === 0 ? (
        <p className="text-gray-500">No excavation points yet.</p>
      ) : (
        <ul className="space-y-4">
          {points.map((point) => (
            <li
              key={point.id}
              className="border rounded-lg p-4 bg-white shadow-sm"
            >
              <h2 className="font-semibold">{point.name}</h2>
              <p className="text-sm text-gray-600">{point.description}</p>
              <p className="text-sm">
                Depth: {point.depth ?? "-"} | Status: {point.status}
              </p>
              {point.coordinates && (
                <p className="text-xs text-gray-500">
                  Lat: {point.coordinates.coordinates[1]}, Lng:{" "}
                  {point.coordinates.coordinates[0]}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Excavation;
